export default {
    regular: "400",
    semibold: "600",
} as const;
